import { render } from "./StatementPage.vue?vue&type=template&id=2f8012f2"
import script from "./StatementPage.vue?vue&type=script&lang=js"
export * from "./StatementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__